import classNames from "classnames";
import React, { FunctionComponent, memo } from "react";

import { ISectionProps, Section } from "./Section";

import "./_section.scss";

export type TSubSectionRole = "top" | "middle" | "bottom";

export interface ISubSectionProps extends ISectionProps {
  role?: TSubSectionRole;
}

export const SubSection: FunctionComponent<ISubSectionProps> = memo(props => {
  const baseClass = "sub-section";

  return (
    <Section
      {...props}
      className={classNames(props.className, `${baseClass}--position-${props.role || "middle"}`)}
      shadow="none"
    />
  );
});
